import React, { useEffect, useState } from "react";
import MJlogo from "../../../../assets/images/logo/mj.png";
import LogoTwo from "../../../../assets/images/logo/logo-two.png";
import { Card, Row, Col, Form } from "react-bootstrap";
import { Button, Container } from "react-bootstrap";
import Stack from "@mui/material/Stack";
import TextLabel from "../../basic-component/TextLabel";
import PluginSnackbar from "../../basic-component/Snackbar";
import useAxiosFetchHeaderData from "../../../hooks/useAxiosFetchHeaderData";
import {
  apiHostUrl,
  addCustomerFeedback,
  checkEmail,
  checkMobile,
  getDepartmentAtribute,
  addProspectiveBuyerFeedback,
  minInputValueForClientField,
} from "../../../../constants/constants";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import axios from "axios";
import SurveyDropDown from "../../basic-component/SurveyDropDown";
import API_Routes from "../../../../constants/api-routes";
import { MDBContainer } from "mdb-react-ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import InputGroup from "react-bootstrap/InputGroup";
import { useRef } from "react";
import { Autocomplete,TextField } from "@mui/material";
import DatePickerComponent from "../../basic-component/DatePickerComponent";

export default function AddProspectiveCustomerFeedback() {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  const { t } = useTranslation();
  const { csrfToken } = useSelector((state) => state.csrf);
  const addFeedbackURL = apiHostUrl + addCustomerFeedback;
  const checkEmailURL = apiHostUrl + checkEmail;
  const checkMobileURL = apiHostUrl + checkMobile;
  const getDepartmentAtributeMapURL = apiHostUrl + getDepartmentAtribute;
  const addProspectiveBuyerFeedbackURL =
    apiHostUrl + addProspectiveBuyerFeedback;
  const [headers, setHeaders] = useState({
    "X-Csrf-Token": csrfToken,
    // 'Content-Type': 'application/json',
    // 'Access-Control-Allow-Credentials': true
  });
  const [registeredEmail, setRegisteredEmail] = useState(false);
  const [registeredMobile, setRegisteredMobile] = useState(false);
  const { departmentId } = useParams();
  const [snackbarMessage, setSnackbarMessage] = useState(
    t("Your feedback added successfully")
  );
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessages] = useState([]);


  const [dropDownData, setDropDownData] = useState([]);
  const [emailVal, setEmailVal] = useState("");
  const [mobileVal, setMobileVal] = useState("");
  const [deptvalue, setDepartMentValue] = useState("");

  const [firstNameVal, setFirstNameValue] = useState("");
  const [lastNameVal, setLastNameValue] = useState("");
  const [orgName, setOrgNameValue] = useState("");
  const [phone, setphoneValue] = useState("");
  const [gst, setgstValue] = useState("");
  const [descriptionVal, setDescriptionVal] = useState("");

  const ref = useRef(null);
  const getCaptchaWTimeUrl = () => {
    return API_Routes.getCaptchaWOTimeUrl + Date.now();
  };
  const [captchaImg, setCaptchaImg] = useState(getCaptchaWTimeUrl());
  const refreshCaptchaHandler = () => {
    setCaptchaImg(getCaptchaWTimeUrl());
  };
  const [captchaCode, setCaptchaCode] = useState("");

  const [payloadVal, setPayloadVal] = useState("");
  const [emailPayload, setEmailPayload] = useState({
    department: { id: departmentId },
    emailId: "",
  });
  const [emailMobilePayload, setEmailMobilePayload] = useState({
    department: { id: departmentId },
    emailId: emailVal,
    mobileNumber: "",
  });
  const [servicePayload, setServicePayload] = useState({ serviceId: "" });
  // const [finalPayload, setFinalPayload] = useState({ attributeList: [{ attributeId: '', attributeName: '', attributeType: '', attributeVal: '', departmentAttributeId: '', mandatory: '' }], captchaCode: '', department: { id: '' }, description: '', emailId: '', firstName: '', gst: '', lastName: '', mobileNumber: '', organizationName: '', phone: '' })
  const [finalPayload, setFinalPayload] = useState({
    attributeList: [],
    captchaCode: "",
    department: { id: "" },
    description: "",
    emailId: "",
    firstName: "",
    gst: "",
    lastName: "",
    mobileNumber: "",
    organizationName: "",
    phone: "",
  });
  const [departmentAttributeMap,setDepartmentAttributeMap]=useState([]);
  // console.log("departmentId: " + departmentId);

  const componentMappings = {
    LIST: "ClientComponent",
    DATE: "EventDateComponent",
    text: "TextComponent",
  };

  const { fetchData: addFeedbackFunc } = useAxiosFetchHeaderData({
    url: addFeedbackURL,
    method: "post",
    body: { departmentId: departmentId },
    headers: headers,
    onLoad: false,
  });

  const { fetchData: checkEmailFunc } = useAxiosFetchHeaderData({
    url: checkEmailURL,
    method: "post",
    body: emailPayload,
    headers: headers,
    onLoad: false,
  });

  const { fetchData: checkMobileFunc } = useAxiosFetchHeaderData({
    url: checkMobileURL,
    method: "post",
    body: emailMobilePayload,
    headers: headers,
    onLoad: false,
  });

  const { fetchData: checkDeptFunc } = useAxiosFetchHeaderData({
    url: getDepartmentAtributeMapURL,
    method: "post",
    body: servicePayload,
    headers: headers,
    onLoad: false,
  });

  const [isReasonEmpty, setIsReasonEmpty] = useState(false);
  const [emailTyped, setEmailTyped] = useState(false);
  const [mobileTyped, setMobileTyped] = useState(false);
  const [fnameTyped, setFirstTyped] = useState(false);
  const [lnameTyped, setLastTyped] = useState(false);
  const [orgTyped, setOrgTyped] = useState(false);
  const [descTyped, setDescTyped] = useState(false);
  const [captchaTyped, setCaptchaTyped] = useState(false);
  const [dynamicAttrErrorList, setDynamicAttrErrorList] = useState({});
  const [dynamicAttributeValueMap,setDynamicAttributeValueMap] = useState({})

  const handleEmailChange = (e) => {
    setRegisteredEmail(false);
    const email = e.target.value;
    setEmailVal(email);

    if (e.target.value!="") {
      setErrorMessages((prevErrorMessages) =>
        prevErrorMessages.filter((msg) => !msg.includes("emailId"))
      );
    }

    setEmailPayload((prevState) => ({
      ...prevState,
      emailId: email,
    }));
  };

  const handleMobileChange = (e) => {
    setRegisteredMobile(false);
    const mobile = e.target.value;
    
    const regex = /^[1-9]\d*$/;
  
      
    if (regex.test(mobile) || mobile === '') {
      setEmailMobilePayload((prevState) => ({
        ...prevState,
        emailId:emailVal,
        mobileNumber: mobile.slice(0,10),
      }));
      setMobileVal(mobile.slice(0,10));
      }else{
        e.target.value = mobile.replace(/[^\d]/g, '');
      }

    if (e.target.value!="") {
      setErrorMessages((prevErrorMessages) =>
        prevErrorMessages.filter((msg) => !msg.includes("mobileNumber"))
      );
    }
    
  };
  const handlePhoneValueChange =(e)=> {
    const mobile = e.target.value;
    
    const regex = /^[1-9]\d*$/;
  
      
    if (regex.test(mobile) || mobile === '') {
      setphoneValue(mobile.slice(0,10));
      e.target.value=mobile.slice(0,10);
      }else{
        e.target.value = mobile.replace(/[^\d]/g, '');
      }
  };

  const handleDeptChange = async (dataId) => {
    setDynamicAttrErrorList([]);
    setDynamicAttributeValueMap({});
    console.log(dataId);
    const serviceId = dataId;
    setDepartMentValue(serviceId);
    setFinalPayload((prev) => ({
      ...prev,
      ["attributeList"]:[],
      ["department"]: {
        ...prev.department,
        ["id"]: dataId,
        
      },
    }));

    setServicePayload((prevState) => ({
      ...prevState,
      serviceId: serviceId,
    }));
    try {
      const response = await axios.post(
        getDepartmentAtributeMapURL,
        { serviceId: serviceId },
        {
          withCredentials: true,
          headers,
        }
      );
      setDepartmentAttributeMap(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  // Call checkEmailFunc() when the email field loses focus
  const handleEmailBlur = () => {
    if (!emailVal || emailVal.trim() === '') {
        return;
    }
    checkEmailFunc().then((res) => {
      console.log(res);
      if (res?.data?.status === "Exist") {
        setSnackbarMessage("This user already exists");
        setShowModal(true);
        setRegisteredEmail(true);
      }
    });
    setFinalPayload((prev) => ({
      ...prev,
      ["emailId"]: emailVal,
    }));
  };
    // Call checkMobileFunc() when the mobile field loses focus
  const handleMobileBlur = () => {
    if (!mobileVal || mobileVal.trim() === '') {
        return;
    }
    checkMobileFunc().then((res) => {
      console.log(res);
        if (res?.data?.status === "Exist") {
          setSnackbarMessage("This user already exists");
          setShowModal(true);
          setRegisteredMobile(true);
        }
      });

    setFinalPayload((prev) => ({
      ...prev,
      ["mobileNumber"]: mobileVal,
    }));
  };

  useEffect(() => {
    addFeedbackFunc().then((response) => {
      const modifiedData = response?.data?.departmentList.map((item) => {
        return { id: item.id, desc: item.description };
      });

      setDropDownData((prevData) => [...prevData, ...modifiedData]);
      handleDeptChange(departmentId);
    });
  }, []);

  const firstnameBlur = () => {
    setFinalPayload((prev) => ({
      ...prev,
      ["firstName"]: firstNameVal,
    }));
  };
  const lastnameBlur = () => {
    setFinalPayload((prev) => ({
      ...prev,
      ["lastName"]: lastNameVal,
    }));
  };
  const orgnameBlur = () => {
    setFinalPayload((prev) => ({
      ...prev,
      ["organizationName"]: orgName,
    }));
  };
  const phoneBlur = () => {
    setFinalPayload((prev) => ({
      ...prev,
      ["phone"]: phone,
    }));
  };
  const gstBlur = () => {
    setFinalPayload((prev) => ({
      ...prev,
      ["gst"]: gst,
    }));
  };
 
  
  const checkAndSetDynamicAttributeErrors = (errorLists) =>{
    
    console.log(dynamicAttrErrorList);
    const allErrors={};
      Object.values(errorLists).forEach((value)=>{
        const array= value.substring(0,value.indexOf('@')).split('_');
        
        if(array.length===4){
          const errormsg= value.split('@')[1].split('.')[0];
          allErrors[array[1]]=errormsg;
          
        }
        
      });
      setDynamicAttrErrorList(allErrors);
  }

  
  const captchaBlur = () => {
    setFinalPayload((prev) => ({
      ...prev,
      ["captchaCode"]: captchaCode,
    }));
  };

  const submithandler = async () => {
    
    try {
      await axios
        .post(addProspectiveBuyerFeedbackURL, finalPayload, {
          withCredentials: true,
          headers,
        })
        .then((data) => {
        
          if (data.data.success === false) {

            //Diganta : Backend validation for registered email
            if (data.data.responseDetails === "This email is already registered") {
                setSnackbarMessage("This email is already registered");
                setShowModal(true);
                setRegisteredEmail(true);
                return;
            }
            //Diganta : Backend validation for registered mobile
            if (data.data.responseDetails === "This mobile number is already registered") {
                setSnackbarMessage("This mobile number is already registered");
                setShowModal(true);
                setRegisteredMobile(true);
                return;
            }

            const errorMessages = data.data.responseDetails.map((detail) => {
              const errorMessagePart = detail.codes[detail.codes.length-1];
              return errorMessagePart;
            });
            if(errorMessages.length>0){
              ref.current?.scrollIntoView({behavior:'smooth'});
            }
            setErrorMessages(errorMessages);
            checkAndSetDynamicAttributeErrors(errorMessages)
            refreshCaptchaHandler();
          } else if (data.data.success === true) {
            setSnackbarMessage(data.data.responseDetails);
            setShowModal(true);
            setDescriptionVal("");
            setCaptchaCode("");
            refreshCaptchaHandler();
            setErrorMessages([]);
            setDynamicAttrErrorList({})
            setDynamicAttributeValueMap({});
            setFinalPayload((prev)=>({
              ...prev,["attributeList"]:[],
            }));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDynamicAttributeChange = (val,attribute)=>{
    
    if(val===null || val==="-1" || val===""){
      const {[attribute.attributeName]: _, ...rest} = dynamicAttributeValueMap;
      setDynamicAttributeValueMap(rest);
      setDataToPayload("",attribute)
    }else{
      setDynamicAttributeValueMap({...dynamicAttributeValueMap,[attribute.attributeName]:val,});
      const {[attribute.departmentAttributeId]: _,[attribute.attributeName]: __,...rest}=dynamicAttrErrorList;
      setDynamicAttrErrorList(rest);
      setDataToPayload(val.departmentAttributeValId?val.departmentAttributeValId:val,attribute);
    }
      

  };
  const setDataToPayload = (val, attribute) => {
    var finalAttributeList = finalPayload.attributeList;
    var payloadContainsList=false
    finalAttributeList.forEach((item) => {
      if(item.attributeName === attribute.attributeName){
        payloadContainsList= true;
      }
    })
    
    if (payloadContainsList && val!="") {
        console.log(finalPayload);
        setFinalPayload((prev) => ({
            ...prev,
            attributeList: prev.attributeList.map((item) => {
                if (item.attributeName === attribute.attributeName) {
                    return {
                        ...item,
                        attributeVal: val,
                    };
                }
                return item;
            }),
        }));
    } else {
        if (val !== "") {
            const newData = {
                attributeType: attribute.attributeType,
                departmentAttributeId: attribute.departmentAttributeId || "",
                attributeId: attribute.attributeId || "",
                mandatory: attribute.mandatory || "",
                attributeName: attribute.attributeName || "",
                attributeVal: val || "",
            };
            finalAttributeList.push(newData);
            setFinalPayload((prev) => ({
                ...prev,
                attributeList: finalAttributeList,
            }));
        } else {
            var filteredFinalAttributeList = finalAttributeList.filter(item => item.attributeName !== attribute.attributeName);
            setFinalPayload((prev) => ({
                ...prev,
                attributeList: filteredFinalAttributeList,
            }));
        }
    }
  };

  var minInputValReq = minInputValueForClientField;
  return (
    <div className="survey-main b-2">
      <PluginSnackbar
        open={showModal}
        message={snackbarMessage}
        onClose={() => setShowModal(false)}
      />

      <Container fluid>
        <Row>
          <Col lg="6" className="my-3 mb-5">
            <div className="logo mb-3">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-end"
                spacing={2}
              >
                <img src={MJlogo}></img>
                <img src={LogoTwo}></img>
              </Stack>
            </div>
            <Card className="survey-section">
              <Card.Header className="light-blue-bg fs-5 fw-medium px-4">
                <Row>
                  <Col className="fs-5">Please provide your feedback</Col>

                  <Col
                    lg="auto"
                    className="timer-area d-flex align-items-center"
                  >
                    {/* {surveyFetchData?.data?.surveyList[0]?.surveyTimerEnable && (
                        <div>
                          <img src={TimerClock} alt="Timer Clock" />
                          <TimerWithHours
                            text={t('label.new.survey.timeleft')}
                            countdown={surveyFetchData?.data?.surveyList[0]?.surveyTime}
                            onTimerUpdate={handleTimerUpdate}
                          />
                        </div>
                      )} */}
                  </Col>
                </Row>
              </Card.Header>
              <div>
                <form onSubmit={handleSubmit(submithandler)} >
                  <Card.Body className="p-4 overflow-auto">
                    <Row ref={ref}>
                      <Col lg="12">
                        <Form.Label className="fs-6 fw-medium mb-0">
                          <TextLabel title={"Contact Details"} />{" "}
                        </Form.Label>
                        <hr className="m-0 mb-2"></hr>
                      </Col>
                      <Col lg="6" className="mb-3">
                        <TextLabel
                          title={t("general.label.email")}
                          isMandatory={true}
                        >
                          {" "}
                        </TextLabel>
                        <Form.Control
                          type="email"
                          id="Email"
                          value={emailVal}
                          onChange={handleEmailChange}
                          onBlur={handleEmailBlur}
                          isInvalid={errorMessage.some((msg) =>
                            msg.includes("emailId")
                          )}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errorMessage.find((msg) =>
                            msg.includes("emailId")
                          ) &&
                            errorMessage
                              .find((msg) => msg.includes("emailId"))
                              .split("@")[1]}
                        </Form.Control.Feedback>
                      </Col>
                      <Col lg="6" className="mb-3">
                        <TextLabel
                          title={t("general.field.mobile.label")}
                          isMandatory={true}
                        >
                          {" "}
                        </TextLabel>
                        <Form.Control
                          type="text"
                          id="Mobile_Number"
                          value={mobileVal}
                          onChange={handleMobileChange}
                          onBlur={handleMobileBlur}
                          isInvalid={errorMessage.some((msg) =>
                            msg.includes("mobileNumber")
                          )}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errorMessage.find((msg) =>
                            msg.includes("mobileNumber")
                          ) &&
                            errorMessage
                              .find((msg) => msg.includes("mobileNumber"))
                              .split("@")[1]}
                        </Form.Control.Feedback>
                      </Col>
                  
                      {departmentId == 0 && (
                        <Col lg="6" className="mb-3">
                          <TextLabel
                            title={t("menu.key.master.department")}
                            isMandatory={true}
                          >
                            {" "}
                          </TextLabel>
                          <Form.Select
                            onChange={(e) => handleDeptChange(e.target.value)}
                          >
                            <option value={deptvalue}>
                              {t("user.department.select.label")}
                            </option>
                            {dropDownData.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.desc}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      )}

                      <Col lg="12">
                        <Form.Label className="fs-6 fw-medium mb-0">
                          <TextLabel title={"Personal Details"} />{" "}
                        </Form.Label>
                        <hr className="m-0 mb-2"></hr>
                      </Col>
                      <Col lg="6" className="mb-3">
                        <TextLabel
                          title={t("general.field.firstName.label")}
                          isMandatory={true}
                        >
                          {" "}
                        </TextLabel>
                        <Form.Control
                          type="text"
                          id="User_Name"
                          onChange={(e) => {
                            setFirstNameValue(e.target.value);
                            if (e.target.value!="") {
                              setErrorMessages((prevErrorMessages) =>
                                prevErrorMessages.filter(
                                  (msg) => !msg.includes("firstName")
                                )
                              );
                            }
                          }}
                          onBlur={firstnameBlur}
                          isInvalid={errorMessage.some((msg) =>
                            msg.includes("firstName")
                          )}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errorMessage.find((msg) =>
                            msg.includes("firstName")
                          ) &&
                            errorMessage
                              .find((msg) => msg.includes("firstName"))
                              .split("@")[1]}
                        </Form.Control.Feedback>
                      </Col>
                      <Col lg="6" className="mb-3">
                        <TextLabel
                          title={t("general.field.lastName.label")}
                          isMandatory={true}
                        >
                          {" "}
                        </TextLabel>
                        <Form.Control
                          type="text"
                          id="Last_Name"
                          onChange={(e) => {
                            setLastNameValue(e.target.value);
                            if (e.target.value!="") {
                              setErrorMessages((prevErrorMessages) =>
                                prevErrorMessages.filter(
                                  (msg) => !msg.includes("lastName")
                                )
                              );
                            }
                          }}
                          onBlur={lastnameBlur}
                          isInvalid={errorMessage.some((msg) =>
                            msg.includes("lastName")
                          )}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errorMessage.find((msg) =>
                            msg.includes("lastName")
                          ) &&
                            errorMessage
                              .find((msg) => msg.includes("lastName"))
                              .split("@")[1]}
                        </Form.Control.Feedback>
                      </Col>
                      <Col lg="6" className="mb-3">
                        <TextLabel
                          title={t("feedbackDetails.organizationName.text")}
                          isMandatory={true}
                        >
                          {" "}
                        </TextLabel>
                        <Form.Control
                          type="text"
                          id="orgName"
                          onChange={(e) => {
                            setOrgNameValue(e.target.value);
                            if (e.target.value!="") {
                              setErrorMessages((prevErrorMessages) =>
                                prevErrorMessages.filter(
                                  (msg) => !msg.includes("organizationName")
                                )
                              );
                            }
                          }}
                          onBlur={orgnameBlur}
                          isInvalid={errorMessage.some((msg) =>
                            msg.includes("organizationName")
                          )}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errorMessage.find((msg) =>
                            msg.includes("organizationName")
                          ) &&
                            errorMessage
                              .find((msg) => msg.includes("organizationName"))
                              .split("@")[1]}
                        </Form.Control.Feedback>
                      </Col>
                      <Col lg="6" className="mb-3">
                        <TextLabel title={t("general.field.phone.label")}>
                          {" "}
                        </TextLabel>
                        <Form.Control
                          type="text"
                          id="Phone_Number"
                          onChange={handlePhoneValueChange}
                          onBlur={phoneBlur}
                        />
                      </Col>
                      <Col lg="6" className="mb-3">
                        <TextLabel title={t("general.lable.gstNo.text")}>
                          {" "}
                        </TextLabel>
                        <Form.Control
                          type="text"
                          id="gst"
                          onChange={(e) => {
                            setgstValue(e.target.value);
                          }}
                          onBlur={gstBlur}
                        />
                      </Col>
                        {(departmentAttributeMap !=null || departmentAttributeMap !== undefined) && Object.values(departmentAttributeMap).map((attribute,index)=>(
                          <Col lg="6">
                          <Form.Group key={index} className="mb-3" >
                            <TextLabel
                            className="testingStars"
                            title={attribute.attributeName}
                            isMandatory={attribute.mandatory === "Y"}
                            ></TextLabel>
                            {attribute.attributeType==="LIST" && attribute.autoComplete===true &&
                            (
                              <Form.Group>
                                <Autocomplete
                                disablePortal
                                id={attribute.attributeId}
                                value={dynamicAttributeValueMap.hasOwnProperty(attribute.attributeName)?dynamicAttributeValueMap[attribute.attributeName]:null}
                                options={attribute.attributeMasterValueList}
                                getOptionLabel={(option)=>
                                  option?.desc ? option.desc : option.attributeVal
                                }
                                onChange={(event, newValue) => {
                                  console.log(newValue);
                                  newValue !== null
                                    ? handleDynamicAttributeChange(newValue, attribute)
                                    : handleDynamicAttributeChange(null, attribute);
                                }}
                                renderInput={(params) => <TextField {...params} />}
                                sx={{ minWidth: "10vw", height: "auto" }}
                                clearIcon={false}
                                filterOptions={(options, state) => {
                                  if (state.inputValue.length < minInputValReq) {
                                    return [];
                                  } else {
                                    const filteredOptions = options.filter((ele) =>
                                      ele?.desc
                                        ? ele.desc
                                            .toLowerCase()
                                            .includes(state.inputValue.toLowerCase())
                                        : ele.attributeVal
                                            .toLowerCase()
                                            .includes(state.inputValue.toLowerCase())
                                    );
                                    if (filteredOptions.length === 0) {
                                      return [
                                        {
                                          attributeVal: -1,
                                          desc: "No data was found",
                                          attributeName: "",
                                        },
                                      ];
                                    } else {
                                      return filteredOptions;
                                    }
                                  }
                                }}
                                noOptionsText={t("min.letter.required", {
                                  num: minInputValReq,
                                })}
                                getOptionDisabled={(option) => option.attributeVal === -1}
                                />
                                {dynamicAttrErrorList[attribute?.departmentAttributeId] && (
                                  <span className="text-danger">
                                        {dynamicAttrErrorList[attribute?.departmentAttributeId]}
                                  </span>
                                )}
                              </Form.Group>

                            )}
                            {attribute.attributeType==="LIST" && attribute.autoComplete===false &&(
                              <Form.Group>
                                <Form.Select
                                value={dynamicAttributeValueMap.hasOwnProperty(attribute.attributeName)?dynamicAttributeValueMap[attribute.attributeName]:"-1"}
                                onChange={(e) => handleDynamicAttributeChange(e.target.value,attribute)}
                                
                                >
                                <option value='-1'>
                                  Select {attribute.attributeName}
                                </option>
                                {attribute.attributeMasterValueList.map((item) => (
                                  <option key={item.departmentAttributeValId} value={item.departmentAttributeValId}>
                                    {item.attributeVal}
                                  </option>
                                ))}
                              </Form.Select>
        
                                {dynamicAttrErrorList[attribute?.departmentAttributeId] && (
                                    <span className="text-danger" type="invalid">
                                          {dynamicAttrErrorList[attribute?.departmentAttributeId]}
                                    </span>
                                  )}
                              
                            </Form.Group>
                            )}
                            {attribute.attributeType==="DATE" &&(
                              <Form.Group>
                                <DatePickerComponent
                                
                                  isMandatory={attribute.mandatory == "Y" ? true : false}
                                  defaultValue={dynamicAttributeValueMap.hasOwnProperty(attribute.attributeName)?dynamicAttributeValueMap[attribute.attributeName]:null}
                                  width={"-webkit-fill-available"}
                                  onChange={(e) => handleDynamicAttributeChange(e, attribute)}
                                  attribute={attribute}
                                ></DatePickerComponent>
                                
                                  {dynamicAttrErrorList[attribute?.departmentAttributeId] && (
                                    <span className="text-danger" type="invald">
                                      {dynamicAttrErrorList[attribute?.departmentAttributeId]}
                                    </span>
                                  )}
                              </Form.Group>

                            )}
                            {attribute.attributeType === "INPUT" && (
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  value={dynamicAttributeValueMap.hasOwnProperty(attribute.attributeName)?dynamicAttributeValueMap[attribute.attributeName]:null}
                                  placeholder={`Enter ${attribute.attributeName}`}
                                  isMandatory={attribute.mandatory == "Y" ? true : false}
                                  onChange={(e)=> handleDynamicAttributeChange(e.target.value,attribute)}
                                />
                                  {dynamicAttrErrorList[attribute?.departmentAttributeId] && (
                                    <span className="text-danger" type="invald">
                                      {dynamicAttrErrorList[attribute?.departmentAttributeId]}
                                    </span>
                                  )}
                              </Form.Group>
                            )}
                            {attribute.attributeType === "INT" && (
                              <Form.Group>
                                <Form.Control
                                  type="number"
                                  value={dynamicAttributeValueMap.hasOwnProperty(attribute.attributeName)?dynamicAttributeValueMap[attribute.attributeName]:null}
                                  placeholder={`Enter ${attribute.attributeName}`}
                                  onChange={(e)=> handleDynamicAttributeChange(e.target.value,attribute)}
                                />
                                  {dynamicAttrErrorList[attribute?.departmentAttributeId] && (
                                    <span className="text-danger" type="invald">
                                      {dynamicAttrErrorList[attribute?.departmentAttributeId]}
                                    </span>
                                  )}
                              </Form.Group>
                            )}
                            {attribute.attributeType === "text" && (
                              <Form.Group>
                                <Form.Control
                                  as="input"
                                  type="text"
                                  value={dynamicAttributeValueMap.hasOwnProperty(attribute.attributeName)?dynamicAttributeValueMap[attribute.attributeName]:""}
                                  rows={3}
                                  placeholder={`Enter ${attribute.attributeName}`}
                                  onChange={(e) =>
                                    handleDynamicAttributeChange(e.target.value,attribute)
                                  }
                                />
                                  {dynamicAttrErrorList[attribute?.departmentAttributeId] && (
                                    <span className="text-danger" type="invald">
                                      {dynamicAttrErrorList[attribute?.departmentAttributeId]}
                                    </span>
                                  )}
                              </Form.Group>
                            )}
                          </Form.Group>
                          </Col>
                        ))}
 
                      <Col lg="12">
                        <Form.Label className="fs-6 fw-medium mb-0">
                          <TextLabel title={"Feedback Details"} />{" "}
                        </Form.Label>
                        <hr className="m-0 mb-2"></hr>
                      </Col>
                      {/* <Form.Label className='fw-medium'>{t('login.msg.reason')}<span className='text-danger'>*</span></Form.Label> */}
                      <Col lg="12" className="mb-3">
                        <TextLabel
                          title={t("label.new.feedbacklist.Description")}
                          isMandatory={true}
                        >
                          {" "}
                        </TextLabel>
                        <Form.Control
                          className="mt-2"
                          as="textarea"
                          rows={3}
                          value={descriptionVal}
                          onChange={(e) => {
                            setDescriptionVal(e.target.value);
                            setFinalPayload((prev) => ({
                              ...prev,
                              ["description"]: e.target.value,
                            }));
                            if (e.target.value!="") {
                              setErrorMessages((prevErrorMessages) =>
                                prevErrorMessages.filter(
                                  (msg) => !msg.includes("description")
                                )
                              );
                            }
                          }}
                          isRequired={true}
                          isInvalid={errorMessage.some((msg) =>
                            msg.includes("description")
                          )}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errorMessage.find((msg) =>
                            msg.includes("description")
                          ) &&
                            errorMessage
                              .find((msg) => msg.includes("description"))
                              .split("@")[1]}
                        </Form.Control.Feedback>
                      </Col>

                      <Col lg="12" className="mb-3">
                        <MDBContainer
                          style={{
                            padding: "0rem",
                            margin: "0",
                            marginBottom: "1rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            minHeight: "auto",
                            height: "auto",
                          }}
                        >
                          
                          <Form.Group
                            className="mb-3 mt-4"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="fw-medium">
                              {t("general.label.captcha")}
                            </Form.Label>

                            <InputGroup>
                              <InputGroup.Text
                                id="basic-addon1"
                                className="float-start position-static order-0 p-0"
                              >
                                <Stack
                                  gap={0}
                                  direction="row"
                                  className="img-thumbnail"
                                >
                                  <img
                                    src={captchaImg}
                                    alt="Captcha Code"
                                    className="captcha-img border rounded"
                                  />
                                  <Button
                                    variant="link"
                                    size="lg"
                                    onClick={refreshCaptchaHandler}
                                  >
                                    <FontAwesomeIcon icon={faArrowsRotate}>
                                      {" "}
                                    </FontAwesomeIcon>
                                  </Button>
                                </Stack>
                              </InputGroup.Text>

                              <Form.Control
                                id="form3"
                                type="text"
                                value={captchaCode}
                                onChange={(e) => {
                                  setCaptchaCode(e.target.value);
                                  setCaptchaTyped(true);
                                  if (captchaTyped) {
                                    setErrorMessages((prevErrorMessages) =>
                                      prevErrorMessages.filter(
                                        (msg) => !msg.includes("captchaCode")
                                      )
                                    );
                                  }
                                }}
                                onBlur={captchaBlur}
                                isInvalid={errorMessage.some((msg) =>
                                  msg.includes("captchaCode")
                                )}
                                placeholder={t("general.placeHolder.captcha")}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errorMessage.find((msg) =>
                                  msg.includes("captchaCode")
                                ) &&
                                  errorMessage
                                    .find((msg) => msg.includes("captchaCode"))
                                    .split("@")[1]}
                              </Form.Control.Feedback>
                            </InputGroup>
                          </Form.Group>
                        </MDBContainer>
                      </Col>
                      
                    </Row>
                  </Card.Body>

                  <Card.Footer className="text-end bg-transparent">
                    {/* <Button variant='outline-dark' type="button"  className='me-3' >Reset</Button> */}
                    <Button variant="primary" type="submit" disabled={registeredEmail || registeredMobile}>
                      {t("general.button.submit.label")}{" "}
                      {isSubmitting && (
                        <span className="spinner-border spinner-border-sm ml-2"></span>
                      )}
                    </Button>{" "}
                  </Card.Footer>
                </form>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
